export class TokenModel {
  public accessToken: string = '';
  // SECURITY: the refresh token is never stored client-side — it lives in an HttpOnly cookie.
  public tokenType: string = 'Bearer';
  public expiresIn: number = 900; // Seconds until access token expires (default 15 min)
  public expiresAt?: number; // Timestamp when token expires (calculated)
  public roles: string[] = []; // User roles decoded from JWT
  public username?: string; // Username decoded from JWT
}
